import { Action } from "../../../actions/actions";
import { HistoryActionTypes } from "../actions/actionTypes";

export function historyUsers(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case HistoryActionTypes.GET_HISTORY_USERS_SUCCESS:
            return action.payload.users;

        default:
            return state;
    }
}

export function historyUsersLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case HistoryActionTypes.GET_HISTORY_USERS:
            return true;

        case HistoryActionTypes.GET_HISTORY_USERS_FAIL:
        case HistoryActionTypes.GET_HISTORY_USERS_SUCCESS:
            return false;

        default:
            return state;
    }
}
